import { createAttachmentApi } from "../../../components/lifecycle/createAttachmentApi";

export const countryAttachmentApi = createAttachmentApi({
  listKey: (entityId, lifecycleName) =>
    ["countryAttachments", entityId, lifecycleName] as const,
  list: (client, { entityId, lifecycleName }) =>
    client.countryListAttachments.countryListAttachments({
      countryId: entityId,
      lifecycleName
    }),
  download: (client, { entityId, lifecycleName, fileName }) =>
    client.countryDownloadAttachment.countryDownloadAttachment(
      { countryId: entityId, lifecycleName, fileName },
      { format: "blob" }
    ),
  delete: (client, { entityId, lifecycleName, fileName }) =>
    client.countryDeleteAttachment.countryDeleteAttachment({
      countryId: entityId,
      lifecycleName,
      fileName
    }),
  upload: { path: "/CountryUploadAttachment", idParameter: "countryId" }
});
